export default __webpack_public_path__ + "static/media/firasans-medium.3aadf3e0.woff2";